<template>
  <div
    :class="{
      'sidebar-item-selected-merchant': true,
      'sidebar-item-selected-merchant--clickable': subMerchantAccounts.length,
      'sidebar-item-selected-merchant--active': showSubMerchantAccounts,
    }"
    @click="$emit('click')"
  >
    <div class="sidebar-item-selected-merchant__merchant-logo">
      <img v-if="merchantProfile.logo" :src="merchantProfile.logo" alt="" />
      <svg-icon v-else icon-class="default-merchant" />
      <svg-icon
        v-if="isCollapsed"
        icon-class="account-collapsed"
        class-name="sub-merchant-arrow--collapsed-menu"
      />
    </div>

    <div class="sidebar-item-selected-merchant__merchant-info">
      <div>
        <el-tooltip placement="bottom" :content="activeSubMerchantName">
          <div class="ellipsis">
            <span class="merchant-info__merchant-name">
              {{ ellipsisEnd(activeSubMerchantName, 10) }}
            </span>
          </div>
        </el-tooltip>
      </div>
      <div class="merchant-info__merchant-id">
        {{ $t('sidebar_id') }}:
        <div dir="ltr" class="merchant-info__merchant-id__text">
          <span class="merchant_code">
            {{ merchantProfile.merchantCode }}
          </span>
          <svg-icon
            icon-class="copy-solid"
            @mouseover.stop="hoverCopyIcon = true"
            @mouseleave.stop="hoverCopyIcon = false"
            @click.stop="handleCopy(merchantProfile.merchantCode)"
          />
        </div>
      </div>
    </div>

    <div
      v-if="subMerchantAccounts.length"
      class="sidebar-item-selected-merchant__suffix-icon"
      :class="{ 'hover-copy-icon': hoverCopyIcon }"
    >
      <svg-icon
        v-if="showSubMerchantAccounts"
        class="sidebar__change-branch-svg"
        :icon-class="!isCollapsed ? 'chevron-up-down' : 'account-collapsed'"
      />
      <svg-icon
        v-else
        :icon-class="!isCollapsed ? 'two-arrows' : 'account-collapsed'"
      />
    </div>
  </div>
</template>

<script>
import { ellipsisEnd } from '@/utils/index.js'
import { getLocalizedValue } from '@/utils/i18n'
import CopyMixin from '@/mixins/copy'

export default {
  name: 'SidebarMerchantAccountSelected',
  mixins: [CopyMixin],
  props: {
    showSubMerchantAccounts: {
      type: Boolean,
      default: false,
    },
    merchantProfile: {
      type: Object,
      default: () => ({}),
    },
    subMerchantAccounts: {
      type: Array,
      default: () => [],
    },
    subMerchants: {
      type: Array,
      default: () => [],
    },
    isCollapsed: {
      type: Boolean,
      default: false,
    },
    activeSubMerchantName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      hoverCopyIcon: false,
    }
  },
  computed: {
    merchantName() {
      const { merchantName, arMerchantName } = this.merchantProfile
      const enName = merchantName || arMerchantName
      const arName = arMerchantName || merchantName

      return getLocalizedValue(enName, arName)
    },
  },
  methods: {
    ellipsisEnd,
  },
}
</script>

<style lang="scss" scoped>
$merchant_logo_size: 32px;

.sidebar-item-selected-merchant {
  display: flex;
  align-items: center;
  height: var(--sidebar-merchant-account-height);
  padding-inline: 24px;
  padding-top: 12px;
  padding-bottom: 12px;
  cursor: pointer;
  background-color: #8267db;

  &__merchant-logo {
    position: relative;
    display: flex;
    flex: 0 0 $merchant_logo_size;
    align-items: center;
    justify-content: center;
    width: $merchant_logo_size;
    height: $merchant_logo_size;
    background-color: #fff;
    border-radius: 6px;

    img {
      width: auto;
      max-width: 100%;
      height: auto;
      max-height: 100%;
    }

    .sub-merchant-arrow--collapsed-menu {
      position: absolute;
      right: -10px;
      bottom: -10px;
      font-size: 20px;
      color: #fff !important;
      cursor: pointer;
      transition: all 0.3s linear;

      &:hover {
        color: #8267db !important;
        stroke: #fff !important;
        stroke-width: 1px;
        transition: all 0.3s linear;
      }

      [dir='rtl'] & {
        right: unset;
        left: -10px;
      }
    }
  }

  &__merchant-info {
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    margin-inline-start: 10px;

    .merchant-info__merchant-name {
      font-size: 12px;
      font-weight: 500;
      line-height: 22px;
      color: #fff;
      text-align: start;
    }

    .merchant-info__merchant-id {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      font-size: 10px;
      font-weight: 400;
      line-height: 16px;
      color: #e5e5e5;
      text-align: start;

      &__text {
        display: flex;
        align-items: center;
        justify-content: flex-start;
      }

      svg {
        margin-inline-start: 4px;
        font-size: 16px;
        color: #ccc !important;
        cursor: pointer;

        &:hover {
          color: #fff !important;
        }
      }

      [dir='rtl'] & {
        .merchant-info__merchant-id__text {
          flex-direction: row-reverse;

          svg {
            margin-inline-start: 0;
            margin-inline-end: 4px;
          }
        }
      }
    }
  }

  &__suffix-icon {
    font-size: 24px;
    color: #999;
    cursor: pointer;

    svg {
      color: #666;
    }
  }

  &:hover {
    .sidebar-item-selected-merchant__suffix-icon {
      color: #fff;
      transition: color 0.3s linear;

      &.hover-copy-icon {
        color: #999;
      }
    }
  }
}
</style>
